export const PROGRESS_IMPORT_CUSTOM_DATA = "import_custom_data";

export const CUSTOM_DATA_USER_FORMULAS = "user_formulas";
export const CUSTOM_DATA_PRODUCTS = "products";
export const CUSTOM_DATA_ENCODING = "encoding";

export const PROCESSING_CUSTOM_FORMULAS = "processing_custom_formulas";
export const PROCESSING_CUSTOMERS = "processing_customers";
